module.exports = __webpack_public_path__ + "img/hood neckline length.93e341fc.png";